module.exports = __webpack_public_path__ + "img/banner7.6a93dd11.jpg";